/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link } from "react-router-dom";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";
import { StyledProps } from "~/tools";

function LogoComponent({ className }: StyledProps) {
  return (
    <StyledLink to="/">
      <h1 className={className} id="logo">
        <IbmWrapper>IBM</IbmWrapper>{" "}
        <McaWrapper>
          <span className="full-name">Multicloud Accelerator</span>
          <span className="abbreviated-name">MCA</span>
        </McaWrapper>
      </h1>
    </StyledLink>
  );
}

const StyledLink = styled(Link)`
  color: inherit;
  white-space: nowrap;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;

const IbmWrapper = styled.span`
  font-family: "IBM Plex Sans Light", sans-serif;
  font-weight: 200;
`;

const McaWrapper = styled.span`
  font-family: "IBM Plex Sans Medium", sans-serif;
  font-weight: ${theme.fontWeights.medium};

  > .abbreviated-name {
    display: none;
  }

  @media screen and (max-width: ${theme.breakpoints.xl}px) {
    > .full-name {
      display: none;
    }

    > .abbreviated-name {
      display: initial;
    }
  }
`;

export const Logo = styled(LogoComponent)`
  font-size: ${theme.fontSizes.xl};
  line-height: 2rem;
  margin-right: ${theme.spacing.spacing07};
`;
